import React, { useState } from 'react';
import { Input } from './Input';
import { Button } from './Button';

interface ArrayInputProps {
  id: string;
  label: string;
  items: string[];
  setItems: (items: string[]) => void;
  placeholder?: string;
  className?: string;
}

export const ArrayInput: React.FC<ArrayInputProps> = ({ id, label, items, setItems, placeholder = "Voeg item toe", className }) => {
  const [currentItem, setCurrentItem] = useState('');

  const handleAddItem = () => {
    if (currentItem.trim() !== '' && !items.includes(currentItem.trim())) {
      setItems([...items, currentItem.trim()]);
      setCurrentItem('');
    }
  };

  const handleRemoveItem = (itemToRemove: string) => {
    setItems(items.filter(item => item !== itemToRemove));
  };

  return (
    <div className={`mb-4 ${className}`}>
      <label htmlFor={id} className="block text-sm font-medium text-neutral-700 mb-1">{label}</label>
      <div className="flex items-center space-x-2 mb-2">
        <Input
          type="text"
          id={id}
          value={currentItem}
          onChange={(e) => setCurrentItem(e.target.value)}
          placeholder={placeholder}
          className="flex-grow"
          onKeyDown={(e) => { if(e.key === 'Enter') { e.preventDefault(); handleAddItem();}}}
        />
        <Button type="button" onClick={handleAddItem} variant="secondary" size="small">Toevoegen</Button>
      </div>
      {items.length > 0 && (
        <ul className="list-disc list-inside pl-1 space-y-1 max-h-32 overflow-y-auto bg-neutral-50 p-2 rounded">
          {items.map((item, index) => (
            <li key={index} className="text-sm text-neutral-700 flex justify-between items-center">
              <span>{item}</span>
              <button
                type="button"
                onClick={() => handleRemoveItem(item)}
                className="text-red-500 hover:text-red-700 text-xs ml-2"
              >
                Verwijder
              </button>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};
